import api from './api';

const STATIC_CATEGORIES = ['Design', 'Engineering', 'Infrastructure', 'Sustainability', 'Technology', 'Projects', 'News'];

// Map form (camelCase) → API (snake_case)
const toApiFormat = (data) => ({
  title: data.title,
  excerpt: data.excerpt,
  content: data.content,
  publish_date: data.publishDate,
  is_draft: data.status !== 'published',
  category: data.category,
  meta_title: data.metaTitle,
  meta_description: data.metaDescription,
  ...(data.coverImage ? { cover_image: data.coverImage } : {})
});

// Map API response → form (camelCase)
const fromApiFormat = (data) => ({
  id: data.id,
  slug: data.slug,
  title: data.title || '',
  excerpt: data.excerpt || '',
  content: data.content || '',
  coverImage: data.cover_image || data.coverImage || null,
  category: data.category || '',
  metaTitle: data.meta_title || data.metaTitle || '',
  metaDescription: data.meta_description || data.metaDescription || '',
  publishDate: data.publish_date || data.publishDate || '',
  status: (data.is_draft === false || data.is_draft === 0) ? 'published' : 'draft',
  author: data.author || '',
  createdAt: data.created_at || data.createdAt || '',
  updatedAt: data.updated_at || data.updatedAt || ''
});

export const blogService = {
  getAll: async (params = {}) => {
    const response = await api.get('/blogs', { params });
    // Response shape: { success: true, data: { current_page, data: [...], total, last_page, per_page } }
    const paginator = response.data?.data ?? response.data;
    const list = Array.isArray(paginator.data)
      ? paginator.data
      : Array.isArray(paginator)
      ? paginator
      : [];

    return {
      data: {
        blogs: list.map(fromApiFormat),
        total: paginator.total ?? list.length,
        page: paginator.current_page ?? params.page ?? 1,
        totalPages: paginator.last_page ?? Math.ceil((paginator.total ?? list.length) / (paginator.per_page || params.limit || 10))
      }
    };
  },

  getBySlug: async (slug) => {
    const response = await api.get(`/blogs/${slug}`);
    // { success: true, data: { ...blog } }
    const blog = response.data?.data ?? response.data;
    return { data: fromApiFormat(blog) };
  },

  create: async (data) => {
    const response = await api.post('/blogs', toApiFormat(data));
    const blog = response.data?.data ?? response.data;
    return { data: fromApiFormat(blog) };
  },

  update: async (slug, data) => {
    const response = await api.put(`/blogs/${slug}`, toApiFormat(data));
    const blog = response.data?.data ?? response.data;
    return { data: fromApiFormat(blog) };
  },

  delete: async (slug) => {
    return api.delete(`/blogs/${slug}`);
  },

  toggleStatus: async (slug) => {
    const response = await api.patch(`/blogs/${slug}/toggle-status`);
    const blog = response.data?.data ?? response.data;
    return { data: fromApiFormat(blog) };
  },

  getCategories: async () => {
    return { data: STATIC_CATEGORIES };
  }
};
